import type { GradeShareData } from './types'

const CODE_PATTERN = /^[a-zA-Z0-9_-]{6,128}$/
const SANDBOX_CODE_PREFIX = 'sdbx_'

const PROD_API_BASE = (
  process.env.REACT_APP_GRADE_SHARE_API_BASE_URL ??
  process.env.REACT_APP_API_BASE ??
  'http://localhost:8080'
).replace(/\/+$/, '')

const SANDBOX_API_BASE = (
  process.env.REACT_APP_GRADE_SHARE_SANDBOX_API_BASE_URL ??
  PROD_API_BASE
).replace(/\/+$/, '')

function apiBaseForCode(code: string) {
  return code.toLowerCase().startsWith(SANDBOX_CODE_PREFIX) ? SANDBOX_API_BASE : PROD_API_BASE
}

export function normalizeGradeShareData(data: GradeShareData): GradeShareData {
  const referralCode = data.user.referralCode?.trim().toUpperCase()
  return {
    ...data,
    user: {
      ...data.user,
      referralCode: referralCode || undefined,
    },
  }
}

/**
 * Resolve a share code to its grade report.
 */
export async function getGradeShare(code: string): Promise<GradeShareData | null> {
  if (!CODE_PATTERN.test(code)) return null

  const apiBase = apiBaseForCode(code)
  const res = await fetch(
    `${apiBase}/api/v1/grade-sharing/public/${encodeURIComponent(code)}`,
    { cache: 'no-store' },
  )
  if (res.status === 404 || res.status === 403) return null
  if (!res.ok) throw new Error(`Failed to load grade share ${code}: ${res.status}`)
  return normalizeGradeShareData((await res.json()) as GradeShareData)
}
